import { forwardRef, useRef, useLayoutEffect } from 'react';
import styles from './CheckboxInput.module.scss.js';
import { jsx } from 'react/jsx-runtime';
import { useThemeVariable } from '../../util/useThemeVariable.js';
import { combineRefs } from '../../util/combineRefs.js';
import classNames from 'clsx';

const CheckboxInput = /*#__PURE__*/forwardRef(
/**
 * A checkbox input that can be checked, unchecked, or indeterminate.
 */
function CheckboxInput(props, forwardedRef) {
  const {
    autoComplete = 'off',
    indeterminate,
    name,
    tag = name,
    variant = 'default',
    size = 'default',
    className: callerClassName,
    UNSAFE_active,
    UNSAFE_focus,
    UNSAFE_hover,
    ...inputProps
  } = props;
  const ref = useRef();
  const checkboxStyle = useThemeVariable('UNSAFE-dsx-checkbox-style', ref);

  // Firefox has a rendering issue going from `appearance: none` to `appearance: auto`
  // during paint (the layout effect invoked in the `useThemeVariable` hook).
  // To avoid this, it's important to default to the native style when checkboxStyle
  // is undefined, rather than defaulting to the custom style.
  const useCustomVisuals = checkboxStyle === 'custom';
  useLayoutEffect(() => {
    if (ref.current) {
      ref.current.indeterminate = !!indeterminate;
    }
  });
  const className = classNames('dsx-component', styles[variant], styles[`size-${size}`], useCustomVisuals ? styles['duel-checkbox'] : styles['checkbox'], UNSAFE_active && styles['active'], UNSAFE_focus && styles['focus'], UNSAFE_hover && styles['hover'], callerClassName);
  return /*#__PURE__*/jsx("input", {
    ...inputProps,
    name: name,
    type: "checkbox",
    className: className,
    ref: combineRefs(ref, forwardedRef),
    autoComplete: autoComplete,
    "data-dsx--checkbox-input": tag
  });
});

export { CheckboxInput };
